var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4385C0 5.81106 5.37258 0.438477 12 0.438477H38C44.6274 0.438477 50 5.81106 50 12.4385V38.4385C50 45.0659 44.6274 50.4385 38 50.4385H12C5.37258 50.4385 0 45.0659 0 38.4385V12.4385Z",
    fill: "#0071CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.9385H23.25V20.6885H32V28.5635H17.125V39.9385H11V11.9385ZM32 18.9385H25V11.9385L32 18.9385ZM20.625 31.1885H22.375C23.25 31.2432 23.9609 31.5166 24.5625 32.0635C25.1094 32.665 25.3828 33.376 25.4375 34.251C25.3828 35.126 25.1094 35.8916 24.5625 36.4385C23.9609 36.9854 23.25 37.3135 22.375 37.3135H21.5V39.0635V39.9385H19.75V39.0635V36.4385V32.0635V31.1885H20.625ZM22.375 35.5635C23.1406 35.5088 23.5781 35.0713 23.6875 34.251C23.5781 33.4854 23.1406 33.0479 22.375 32.9385H21.5V35.5635H22.375ZM27.625 31.1885H29.375C30.0859 31.2432 30.6875 31.5166 31.2344 31.9541C31.6719 32.501 31.9453 33.1025 32 33.8135V37.3135C31.9453 38.0791 31.6719 38.6807 31.2344 39.1729C30.6875 39.665 30.0859 39.9385 29.375 39.9385H27.625H26.75V39.0635V32.0635V31.1885H27.625ZM29.375 38.1885C29.9219 38.1885 30.1953 37.8604 30.25 37.3135V33.8135C30.1953 33.2666 29.9219 32.9932 29.375 32.9385H28.5V38.1885H29.375ZM33.75 31.1885H34.625H37.25H38.125V32.9385H37.25H35.5V34.6885H37.25H38.125V36.4385H37.25H35.5V39.0635V39.9385H33.75V39.0635V35.5635V32.0635V31.1885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/icFile.711494614a512d6e046ba3ba9243f9d7.svg";
export { ForwardRef as ReactComponent };